import { Hamburger } from "./class/Hamburger";
import { Details } from "./class/Details";
import { SwiperOperate } from "./class/Swiper";
import { Utils } from "./utils/Utils";

window.addEventListener("DOMContentLoaded", () => {
  // 初期化処理
  setSmoothScroll();
  setSmallWindow();
  setAnimation();
  setLoading();
  setCloseBnrBtn();
  setSearchArea();
  // 使用するコンポーネントの初期化
  new Hamburger(); // ハンバーガーメニュー
  new Details(); // detailsを使用したアコーディオン
  new SwiperOperate(); // スワイパー
});

// -------------------------------------
// 機能：小さい画面の場合は、360pxの画面を縮小したものにする
// -------------------------------------
function setSmallWindow() {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    if (viewport) {
      const value = window.outerWidth > 360 ? "width=device-width,initial-scale=1" : "width=360";
      if (viewport.getAttribute("content") !== value) {
        viewport.setAttribute("content", value);
      }
    }
  }
  addEventListener("resize", switchViewport, false);
  switchViewport();
}

//----------------------------------------------------
// 機能：スムーススクロールをセット
// 引数：なし
// 戻値：なし
//----------------------------------------------------
function setSmoothScroll() {
  const ancLinks = document.querySelectorAll('a[href^="#"]');
  ancLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");
      let target; // 飛び先
      if (href === "#") {
        target = document.querySelector("html");
      } else {
        target = document.querySelector(<string>href);
      }
      if (target) {
        e.preventDefault();
        Utils.scrollTo(target);
      }
    });
  });
}

// -------------------------------------
// 機能：アニメーションの登録
// -------------------------------------
function setAnimation() {
  const scrollIns = document.querySelectorAll(".scrollIn");

  const options = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "0px 0px -20% 0px", // ビューポートの中心を判定基準にする
    threshold: 0,
  };
  const observer = new IntersectionObserver(callback, options);
  if (scrollIns) {
    scrollIns.forEach(function (box) {
      observer.observe(box);
    });
  }

  function callback(entries: any) {
    entries.forEach(function (entry: any, i: number) {
      const target = entry.target;
      if (entry.isIntersecting && !target.classList.contains(".active")) {
        const delay = i * 100;
        setTimeout(function () {
          target.classList.add("active");
        }, delay);
      }
    });
  }
}

// -------------------------------------
// 機能：ローディングアニメーションの登録
// -------------------------------------
function setLoading() {
  // ローディング画面
  const loadingArea = document.getElementById("loadingAnime"); // ローディング画面全体
  if (loadingArea) {
    const images = document.getElementsByTagName("img"); // ページ内のimgタグを取得
    // const percentNumber = document.getElementById("loadingAnime_percentNum"); // ●%の●部分
    const loadingGauge = document.getElementById("loadingAnime_gaugeLine"); // リアルタイムで読み込まれるゲージ部分
    let imgCounting = 0;
    let baseCounting = 0;
    const gaugeWidth = 100; // ゲージの全体幅
    let current;

    // 画像の読み込み
    for (let i = 0; i < images.length; i++) {
      const img = new Image(); // 新たなimg要素を作成
      // 画像読み込み完了したとき
      img.onload = function () {
        imgCounting += 1;
      };
      // 画像読み込み失敗したとき
      img.onerror = function () {
        imgCounting += 1;
      };
      img.src = images[i].src; // ソースのパスを設定
    }
    // setIntervalを使って一定時間ごとに処理を繰り返す
    const nowLoading = setInterval(function () {
      // baseCountingがimgCountingより大きくならない条件の場合に処理を実行させる。2回目以降にページを読み込んだ時に画像の読み込み履歴が残っている関係で、ローディング画面の表示が速く終わってしまうため、その対策として条件をつけている。
      if (baseCounting <= imgCounting) {
        baseCounting += 1;
        // リアルタイムで読み込んでいるパーセントを取得
        current = Math.floor((baseCounting / images.length) * 100);
        // ●%の●部分に数字を置き換える
        // if (percentNumber) {
        //   percentNumber.innerHTML = current.toString();
        // }
        // リアルタイムで読み込まれるゲージ部分を反映させる
        if (loadingGauge) {
          loadingGauge.style.width = Math.floor((gaugeWidth / 100) * current) + "%";
        }
      }
      // 全て読み込んだ時
      if (baseCounting === imgCounting) {
        clearInterval(nowLoading);
        // if (percentNumber) {
        //   percentNumber.innerHTML = "100";
        // }
        if (loadingGauge) {
          loadingGauge.style.width = "100%";
        }
        setTimeout(function () {
          loadingArea.style.opacity = "0";
          setTimeout(function () {
            loadingArea.style.display = "none";
          }, 300); // フェードアウトのための遅延
        }, 500); // 少しの遅延を加える
      }
    }, 50);
  }
}

// -------------------------------------
// バナーの閉じるボタンをセット
// -------------------------------------
function setCloseBnrBtn() {
  const fixedBnr_btn = document.getElementById("fixedBnr_btn");
  const fixedBnr = document.getElementById("fixedBnr");
  if (fixedBnr_btn && fixedBnr) {
    fixedBnr_btn.addEventListener(
      "click",
      () => {
        fixedBnr.style.display = "none";
      },
      { once: true },
    );
  }
}

// -------------------------------------
// 絞り込み検索欄のエリアの初期化
// -------------------------------------
function setSearchArea() {
  // アコーディオンの登録
  const areaListBtns = document.querySelectorAll(".areaListBtn");
  areaListBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true" || false;
      btn.setAttribute("aria-expanded", (!expanded).toString());
    });
  });
  // マップ上のエリア名をクリックしたときに、名称の方にセットされているリンク先に遷移する
  const cities = document.querySelectorAll("#area_block > *");
  cities.forEach((city) => {
    city.addEventListener("click", (event) => {
      // クリックされた要素のdata-name属性の値を取得
      const currentTarget = event.currentTarget as HTMLElement | null;
      if (currentTarget) {
        const dataName = currentTarget.getAttribute("data-name");

        // dataNameと一致するdata-area属性を持つaタグを取得
        const targetLink = document.querySelector(`.areaList a[data-area="${dataName}"]`);

        // 対象のaタグが見つかった場合、そのhref属性(リンク先に遷移)
        if (targetLink) {
          const href = targetLink.getAttribute("href");
          if (href) {
            window.location.href = href;
          }
        }
      }
    });
  });
}
